<template>
    <div class="news_box">
        <div class="box_title">
            专题要闻
        </div>
        <div class="list_box">
            <div class="news_item hvr-grow" v-for="(item, index) in topList" :key="index" @click="showNewsDetail( item )">
                <img :src="item.headpic" v-if="item.headpic && item.headpic.indexOf('http') != -1" alt="">
                <img :src="$ImgUrl + item.headpic" v-if="item.headpic && item.headpic.indexOf('http') == -1" alt="">
                <img src="../../assets/static/index/left_nav_bg3.png" v-if="!item.headpic" alt="">
                <div class="news_content">
                    <span>{{ item.newsTitle }} </span>
                </div>
                <div class="time_box">
                    <div class="left">
                        <span class="iconfont icon-shijian" ></span> {{ item.createTime }}
                    </div>
                    <div class="right">
                        <span class="el-icon-right"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        props: {
            topList: Array
        },
        computed: {
            specialReportId() {
                return Number( this.$route.params.id )
            },
            ...mapGetters(['token'])
        },
        methods: {
            // 查看新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.newsId}`,
                    query: {
                        specialReportId: this.specialReportId
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
.news_box {
    width: 1200px;
    box-sizing: border-box;
    margin: 20px auto;
    .box_title {
        font-size: 24px;
        color: #2767c4 ;
        padding: 10px;
        border-bottom: 1px solid #2767c4 ;
        margin: 20px 0;
        font-weight: bold;
        
    }

    .list_box {
        width: 1200px;
        display: flex;
        justify-content: space-between;
        .news_item {
            border: 1px solid #EEEEEE;
            cursor: pointer;
            img {
                width: 371px;
                height: 224px;
            }
            .news_content {
                font-size: 16px;
                font-weight: bold;
                padding: 20px;
                width: 371px;
                box-sizing: border-box;
                word-break: break-all;
            }
            .time_box {
                color: #c8c8c8;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px;
                border-top: 1px solid #eeeeee;
                
            }
        }
    }
}
</style>